/**
 * 数组去重
 * @param arr 数组 params 判断字段
 */
export function unique(arr, params) {
  let map = new Map();
  for (let item of arr) {
    if (params) {
      if (!map.has(item[params])) {
        map.set(item[params], item);
      }
    } else {
      if (!map.has(item)) {
        map.set(item, item);
      }
    }
  }
  return [...map.values()];
}
/**
 * 获取当前时间
 * @param arr 数组 params 判断字段
 */
export function getTime() {
  let today = new Date();//定义日期对象   
  let yyyy = today.getFullYear();//通过日期对象的getFullYear()方法返回年    
  let MM = today.getMonth() + 1;//通过日期对象的getMonth()方法返回月    
  let dd = today.getDate();//通过日期对象的getDate()方法返回天 
  let day; //用于保存星期（getDay()方法得到星期编号）
  if (today.getDay() == 0) day = "星期日 "
  if (today.getDay() == 1) day = "星期一 "
  if (today.getDay() == 2) day = "星期二 "
  if (today.getDay() == 3) day = "星期三 "
  if (today.getDay() == 4) day = "星期四 "
  if (today.getDay() == 5) day = "星期五 "
  if (today.getDay() == 6) day = "星期六 "
  let currentDate = {
    yyyy: yyyy,
    MM: MM,
    dd: dd,
    day:day
  }
  return currentDate;
}
/**
 *转换时间格式
 * @param dateString 为 Jul 14, 2023 12:00:00 AM格式时间
 */
export function convertDateFormat(dateString) {
    if (!dateString) return '';
    // 创建一个日期对象
    const date = new Date(dateString);

    // 获取年、月、日、小时、分钟和秒
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 月份从 0 开始，所以需要加 1
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // 格式化日期和时间
    const formattedDate = year + '-' + month + '-' + day;
    const formattedTime = hours + ':' + minutes + ':' + seconds;

    // 返回最终的日期时间字符串
    return formattedDate;
}